import {
  UPDATE_USER_DETAILS,
  UPDATE_SELECTED_BSA,
  UPDATE_LEVEL,
  UPDATE_SELECTED_COUNTRYCODE,
  UPDATE_DT_ACCESS,
  ADD_CHANGED_OUTLETSTATUS,
  REMOVE_CHANGED_OUTLETSTATUS,
  CLEAR_CHANGED_OUTLETSTATUSES,
  UPDATE_UCUBE_ACCESS,
  UPDATE_OPSREPORT_ACCESS,
  UPDATE_ADMIN_ACCESS,
  UPDATE_SELECTED_MONTH,
  UPDATE_SELECTED_TAB_ID

} from "./storeActionTypes";

export const updateUserDetailsAction = details => {
  return {
    type: UPDATE_USER_DETAILS,
    payload: {
      userDetails: details,
    },
  };
};

export const updateSelectedBsaAction = bsa => {
  return {
    type: UPDATE_SELECTED_BSA,
    payload: {
      selectedBsa: bsa,
    },
  };
};

export const updateLevelAction = level => {
  return {
    type: UPDATE_LEVEL,
    payload: {
      level: level,
    },
  };
};

export const updateSelectedCountryCodeAction = countryCode => {
  return {
    type: UPDATE_SELECTED_COUNTRYCODE,
    payload: {
      selectedCountryCode: countryCode,
    },
  };
};

export const updateDTAccessAction = dtAccess => {
  return {
    type: UPDATE_DT_ACCESS,
    payload: {
      dtAccess,
    },
  };
};

export const updateAdminAccessAction = admin => {
  return {
    type: UPDATE_ADMIN_ACCESS,
    payload: {
      adminAccess: admin,
    },
  };
};

export const updateUcubeAccessAction = uCube => {
  return {
    type: UPDATE_UCUBE_ACCESS,
    payload: {
      ucubeAccess: uCube,
    },
  };
};

export const updateOpsReportAccessAction = opsReport => {
  return {
    type: UPDATE_OPSREPORT_ACCESS,
    payload: {
      opsReportAccess: opsReport,
    },
  };
};

export const addChangedStatus = status => {
  return {
    type: ADD_CHANGED_OUTLETSTATUS,
    payload: status,
  };
};

export const removeChangedStatus = outletCode => {
  return {
    type: REMOVE_CHANGED_OUTLETSTATUS,
    payload: outletCode,
  };
};

export const clearChangedStatuses = () => {
  return {
    type: CLEAR_CHANGED_OUTLETSTATUSES,
  }
};

export const updateSelectedMonth = monthName => {
  return {
    type: UPDATE_SELECTED_MONTH,
    payload: {
      selectedMonth: monthName,
    },
  };
};

export const updateSelectedTabForID = tab => {
  return {
    type: UPDATE_SELECTED_TAB_ID,
    payload: {
      selectedTabId: tab,
    },
  };
};

